export const SET_ADD_STREAMER = "SET_ADD_STREAMER";
export const SET_REMOVE_STREAMER = "SET_REMOVE_STREAMER";
export const SET_WIPE_STREAMER = "SET_WIPE_STREAMER";
export const SET_EVERY_STREAMER = "SET_EVERY_STREAMER";